import React from 'react';
import _ from 'underscore';
import classnames from 'classnames';
import { useAngularService } from 'helpers/get_angular_service';

interface LinkProps {
  type?: 'link' | 'button';
  variant?:
    | 'default'
    | 'success'
    | 'primary'
    | 'primary--v2'
    | 'info'
    | 'hollow'
    | 'icon'
    | 'icon--v2';
  size?: 'sm' | 'md' | 'lg';
  children: any;
  route: string;
  aliasRoutes?: string[];
  routeParams?: any;
  target?: '_self' | '_blank';
  onClick?: () => void;
  className?: string;
  tooltip?: string;
  activeClassName?: string;
  title?: string;
}

const Link = ({
  type = 'link',
  children,
  variant = 'default',
  size = 'md',
  route,
  aliasRoutes,
  routeParams = {},
  target,
  onClick,
  className,
  tooltip,
  activeClassName,
  title,
}: LinkProps) => {
  const $state = useAngularService('$state');

  const isActive = () => {
    if (!activeClassName) return false;
    if ($state.is(route)) return true;
    if (aliasRoutes) {
      return _.find(aliasRoutes, (item) => $state.is(item));
    }
  };

  const cn = classnames(className, {
    btn: type === 'button',
    [`btn-${variant}`]: type === 'button',
    [`btn-${size}`]: type === 'button',
    [activeClassName]: isActive(),
  });

  return (
    <a
      type={type === 'button' ? 'button' : undefined}
      className={cn}
      href={$state.href(route, routeParams)}
      target={target}
      onClick={onClick}
      data-tip={tooltip}
      title={title}
    >
      {children}
    </a>
  );
};

export default Link;
